import { render, staticRenderFns } from "./ViewUploadedCertificate.vue?vue&type=template&id=016164a2&"
import script from "./ViewUploadedCertificate.vue?vue&type=script&lang=js&"
export * from "./ViewUploadedCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports